import {
  ISettingsParams,
  withoutDefaultFallback,
} from '../../components/BookingCalendar/settingsParams';
import { CalendarContext } from '../context/contextFactory';
import {
  ANY_GENDER_STAFF_LABEL_KEYS,
  GENDER_FILTER_OPTION_KEYS,
} from './translationKeys';
import { RequestedGender } from './types';

const FILTER_LABEL_PARAMS: Record<RequestedGender, keyof ISettingsParams> = {
  [RequestedGender.ANY_FEMALE]: 'anyFemaleStaffFilterLabel',
  [RequestedGender.ANY_MALE]: 'anyMaleStaffFilterLabel',
};

const LABEL_PARAMS: Record<RequestedGender, keyof ISettingsParams> = {
  [RequestedGender.ANY_FEMALE]: 'anyFemaleStaffLabel',
  [RequestedGender.ANY_MALE]: 'anyMaleStaffLabel',
};

const resolveLabel =
  (
    params: Record<RequestedGender, keyof ISettingsParams>,
    keys: Record<RequestedGender, string>,
  ) =>
  ({
    gender,
    context,
  }: {
    gender: RequestedGender;
    context: CalendarContext;
  }): string =>
    context.getContent({
      settingsParam: context.settingsParams[params[gender]],
      translationKey: keys[gender],
    });

/**
 * The short text a filter chip and the staff dropdown carry — "Any female"
 * beside staff names, where the full phrase would not fit.
 */
export const getAnyGenderStaffFilterLabel = resolveLabel(
  FILTER_LABEL_PARAMS,
  GENDER_FILTER_OPTION_KEYS,
);

/**
 * The full phrase — "Any female staff member" — for the places that describe
 * the choice back to the visitor rather than offer it as a chip.
 */
export const getAnyGenderStaffLabel = resolveLabel(
  LABEL_PARAMS,
  ANY_GENDER_STAFF_LABEL_KEYS,
);

/**
 * What the owner typed for the full phrase, and nothing where they left it
 * alone — the preferences modal knows its own default for this text, so it is
 * handed an override only where there is one to hand over.
 */
export const getAnyGenderStaffLabelOverride = ({
  gender,
  context,
}: {
  gender: RequestedGender;
  context: CalendarContext;
}): string | undefined =>
  context.settings.get(
    withoutDefaultFallback(context.settingsParams[LABEL_PARAMS[gender]]),
  ) || undefined;
